import maintenance from "../../assets/maintenance.jpg";

export default function ErrorBoundaryFallBack() {
  return (
    <div className="maintenance-container">
      <img src={maintenance} alt="maintenance" className="maintenance-image" />
      <h1>Something Went Wrong!</h1>
      <p>
        Unfortunately, an unexpected error occurred. We're working to fix it as
        soon as possible.
      </p>
      <p>Thank you for your understanding and patience.</p>
    </div>
  );
}
